<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Moje pohľadničky a albumy pre bábätká"
      header="pre bábätká"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/babatka/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Babatka',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/babatka/babatka1.jpg','/static/images/babatka/babatka2.jpg','/static/images/babatka/babatka3.jpg'],
        title: "Ružové topánočky - 13,50 €",
        subtitle: "Album",
        details: "...roztomilý album pre babätko, s motívom ružových topánočiek so šnúrkami zo stužky, topánočky sú vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Nápis -ten najkrajší darček- je nálepka. Album je polotovar slovenskej výroby. Obsahuje 20 listov v bielej farbe vyššej gramáže. Ozdobená je len vrchná časť, milým bonusom je záložka v podobe ružového cumlíka na bielej ľanovej šnúrke. Poslúži ako fotoalbum alebo zápisníček pre novopečených rodičov.",
        size: "15,2 x 15,2",
        material: "kartón, špagát, stužka",
        kind: "decoupage, lepenie",
        id: 3
      },
      {
        pictutes: ['/static/images/babatka/babatka4.jpg','/static/images/babatka/babatka5.jpg','/static/images/babatka/babatka6.jpg'],
        title: "Ružové papučky - 6,30 €",
        subtitle: "Pohľadnica",
        details: "...milá babätkovská pohľadnička s ružovými papučkami, tie boli vytvorené technikou decoupage, previazané stužkou a nalepené v 3D efekte. Pohľadnica je vrstvená, v bielej farbe bez textov. Posielam s ručne robenou obálkou na mieru.",
        size: "14,5 x 13",
        material: "obyčajný papier, stužka, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 2
      },
      {
        pictutes: ['/static/images/babatka/babatka7.jpg','/static/images/babatka/babatka8.jpg','/static/images/babatka/babatka9.jpg','/static/images/babatka/babatka10.jpg','/static/images/babatka/babatka11.jpg'],
        title: "Modré topánočky - 15,50 €",
        subtitle: "Album",
        details: "...roztomilý album pre babätko, s motívom modrých topánočiek so šnúrkami zo stužky, topánočky sú vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Nápis -Náš chlapček- je nálepka. Album je polotovar slovenskej výroby. Obsahuje 20 listov v bielej farbe vyššej gramáže. Nálepkami sú ozdobené aj vnútorné strany (Vitaj doma, Konečne doma, Prvý úsmev, Prvá fotka...zopár foto prikladám), milým bonusom je záložka v podobe modrého cumlíka na bielej ľanovej šnúrke. Poslúži ako fotoalbum a zápisníček pre novopečených rodičov.",
        size: "15,2 x 15,2 cm",
        material: "kartón, obyčajný papier, špagát",
        kind: "decoupage, lepenie",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Babatka.vue